(function () {
  'use strict';

  function initGallery(root) {
    var main = root.querySelector('.bw-gallery__main');
    if (!main || main.dataset.bwInit) return;
    main.dataset.bwInit = '1';
    var slides = main.querySelectorAll('.bw-gallery__slide');
    var thumbs = root.querySelectorAll('.bw-gallery__thumb');
    var dots = root.querySelectorAll('.bw-gallery__dot');
    function go(i) {
      var s = slides[i];
      if (!s) return;
      main.scrollTo({ left: s.offsetLeft - main.offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); mark(k); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); mark(k); }); });
    main.addEventListener('scroll', function () {
      var i = Math.round(main.scrollLeft / Math.max(main.clientWidth, 1));
      mark(i);
    }, { passive: true });
  }

  function initVariants(root) {
    var select = root.querySelector('[data-bw-variant]');
    var dataEl = root.querySelector('[data-bw-variants]');
    if (!select || !dataEl || select.dataset.bwInit) return;
    select.dataset.bwInit = '1';
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var money = root.querySelector('[data-bw-money]');
    var fmt = money ? money.dataset.bwMoney : '';
    function format(cents) {
      var v = (cents / 100).toFixed(2);
      if (fmt && fmt.indexOf('amount') > -1) {
        return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
      }
      return v;
    }
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      var now = root.querySelector('[data-bw-price]');
      var was = root.querySelector('[data-bw-compare]');
      var save = root.querySelector('[data-bw-save]');
      if (now) now.textContent = format(v.price);
      if (was) {
        was.hidden = !(v.compare_at_price > v.price);
        if (v.compare_at_price) was.textContent = format(v.compare_at_price);
      }
      if (save) {
        var pct = v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        save.hidden = pct <= 0;
        save.textContent = save.dataset.label.replace('%s', pct);
      }
      var btn = root.querySelector('[data-bw-atc]');
      if (btn) {
        var label = btn.querySelector('span');
        if (v.available) { btn.removeAttribute('disabled'); if (label) label.textContent = btn.dataset.add; }
        else { btn.setAttribute('disabled', 'disabled'); if (label) label.textContent = btn.dataset.soldout; }
      }
    });
  }

  function initUgc(root) {
    var more = root.querySelector('.bw-ugc__more');
    if (more && !more.dataset.bwInit) {
      more.dataset.bwInit = '1';
      more.addEventListener('click', function () {
        root.querySelectorAll('.bw-ugc__card.is-hidden').forEach(function (c) { c.classList.remove('is-hidden'); });
        more.remove();
      });
    }
    root.querySelectorAll('.bw-ugc__play').forEach(function (btn) {
      if (btn.dataset.bwInit) return;
      btn.dataset.bwInit = '1';
      btn.addEventListener('click', function () {
        var v = btn.parentElement.querySelector('video');
        if (!v) return;
        v.controls = true;
        v.play();
        btn.remove();
      });
    });
  }

  function initSticky(bar) {
    if (bar.dataset.bwInit) return;
    bar.dataset.bwInit = '1';
    var target = document.querySelector('[data-bw-atc]');
    var btn = bar.querySelector('[data-bw-sticky-btn]');
    var dateEl = bar.querySelector('[data-bw-arrive]');
    if (dateEl && window.bwEdd) {
      dateEl.textContent = window.bwEdd.rangeText();
    } else if (dateEl) {
      var min = parseInt(dateEl.dataset.min, 10) || 5;
      var max = parseInt(dateEl.dataset.max, 10) || 10;
      var opt = { month: 'short', day: 'numeric' };
      var a = new Date(); a.setDate(a.getDate() + min);
      var b = new Date(); b.setDate(b.getDate() + max);
      var loc = document.documentElement.lang || 'en';
      dateEl.textContent = a.toLocaleDateString(loc, opt) + ' – ' + b.toLocaleDateString(loc, opt);
    }
    if (btn) {
      btn.addEventListener('click', function () {
        var form = target ? target.closest('form') : null;
        if (form && !target.disabled) {
          if (form.requestSubmit) form.requestSubmit(); else target.click();
        } else if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (btn.dataset.url) {
          window.location.href = btn.dataset.url;
        }
      });
    }
    if (!target) { bar.classList.add('is-visible'); return; }
    var ticking = false;
    function update() {
      ticking = false;
      var r = target.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-bw-product]').forEach(function (r) { initGallery(r); initVariants(r); });
    s.querySelectorAll('[data-bw-ugc]').forEach(initUgc);
    s.querySelectorAll('[data-bw-sticky]').forEach(initSticky);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Önce / sonra kaydırıcısı */
(function () {
  'use strict';
  function set(frame, v) { frame.style.setProperty('--pos', Math.max(0, Math.min(100, v)) + '%'); }
  document.addEventListener('input', function (e) {
    var r = e.target;
    if (!r.classList || !r.classList.contains('bw-ba__range')) return;
    set(r.closest('[data-bw-ba]'), parseFloat(r.value));
  });
})();
